import { useCallback, useState, useEffect } from "react";

import { Form, Button, Modal, Spin, Popconfirm, Collapse } from "antd";
import { Alert } from "antd";
import { CheckCircleOutlined } from "@ant-design/icons";
import { toast } from "react-toastify";

import { Wrapper } from "./styles";

import { DadosPessoal } from "./components/DadosPessoal";
import { Endereco } from "./components/Endereco";
import { Sistema } from "./components/dadosEnsino";
import { EstagioService } from "../../services/estagio.service";
export function FormEstagio() {
  const { Panel } = Collapse;

  function callback(key) {
    // console.log(key);
  }

  const [form] = Form.useForm();
  const [visible, setVisible] = useState(false);
  const [openSubs, setOpenSub] = useState(true);
  const [state, setState] = useState({
    anexoDeclaracaoMatricula: null,
    anexoCurriculo: null,
    anexoHistoricoAcademico: null,
    anexoCopiaRG: null,
  });

  const [loading, setLoading] = useState(false);
  useEffect(() => {
    var initialDate = new Date("May 16, 2025 10:00:00");
    var endDate = new Date("June 27, 2025 23:59:59");

    if (Date.now() >= initialDate && Date.now() <= endDate) {
      setOpenSub(true);
    } else {
      setOpenSub(false);
    }
  }, []);

  const finish = useCallback(
    async (values) => {
      // console.log("States: " + JSON.stringify(values))
      setLoading(true);
      try {
        if (!state.anexoDeclaracaoMatricula) {
          toast.error("Por favor, coloque o anexo : Declaração de Matrícula ");
          return;
        }

        if (!state.anexoCurriculo) {
          toast.error("Por favor, coloque o anexo: Currículo");
          return;
        }

        if (!state.anexoHistoricoAcademico) {
          toast.error("Por favor, coloque o anexo: Histórico Academico");
          return;
        }

        if (!state.anexoCopiaRG) {
          toast.error("Por favor, coloque o anexo: Cópia RG");
          return;
        }

        if (!values.email.includes("@")) {
          toast.error("Por favor, informe um email válido");
          return;
        }
        if (!values.turnoCurso) {
          toast.error("Por favor, informe o turno de seu cruso");
          return;
        }
        if (!values.turnoDisponibilidade) {
          toast.error("Por favor, informe o turno disponível");
          return;
        }
        if (values.deficiente === null) {
          toast.error("Por favor, informe se possui alguma deficiência");
          return;
        }

        const {
          anexoDeclaracaoMatricula,
          anexoCurriculo,
          anexoHistoricoAcademico,
          anexoCopiaRG,
        } = state;

        // if (values.orgaoLotacao) {
        //   values.orgao = values.orgaoLotacao;
        //   delete values.orgaoLotacao;
        // }

        const patt1 = /[0-9]/g;
        values.cpf = values.cpf.match(patt1).join("");

        // const telefone = values.telefone.match(patt1).join("");
        // const telefoneLotacao = values.telefoneLotacao.match(patt1).join("");

        // const telefoneChefeImediato = values.telefoneChefeImediato
        //   .match(patt1)
        //   .join("");
        // console.log("Chamar API")
        // console.log("Values" + JSON.stringify(values))
        // values.orgaoExpedidor = "SSP"
        values.anexoDeclaracaoMatricula = anexoDeclaracaoMatricula;
        values.anexoHistoricoAcademico = anexoHistoricoAcademico;
        values.anexoCopiaRG = anexoCopiaRG;
        values.anexoCurriculo = anexoCurriculo;

        const { data } = await EstagioService.inscricao({
          ...values,
          // anexoAtestadoAntecedente,
          // anexoCertidaoCGD,
          // anexoIdentidadeFuncional,
          // anexocertidaoForumTJCE,
          // cpf,
          // telefone,
        });
        countDown(data.id);

        form.resetFields();
        setState({
          anexoIdentidadeFuncional: null,
          anexoAtestadoAntecedente: null,
          anexoCertidaoCGD: null,
          anexocertidaoForumTJCE: null,
        });
      } catch (err) {
        console.log(err);
        toast.error("Erro ao tentar salvar a ficha, tente novamente!");
      } finally {
        setLoading(false);
      }
    },
    [form, state]
  );

  const showPopconfirm = () => {
    setVisible(true);
  };

  const updateFile = useCallback(
    (newValues) => setState((prev) => ({ ...prev, ...newValues })),
    []
  );

  function countDown() {
    let secondsToGo = 5;
    // \n Protocolo: ${id}
    const modal = Modal.success({
      title: `Salvo com sucesso. `,
      content: ``,
    });
    const timer = setInterval(() => {
      secondsToGo -= 1;
      modal.update({
        content: `A modal será fechado em ${secondsToGo} segundos.`,
      });
    }, 1000);
    setTimeout(() => {
      clearInterval(timer);
      modal.destroy();
    }, secondsToGo * 1000);
  }

  return (
    <Spin
      spinning={loading}
      style={{
        marginTop: "450px",
        position: "fixed",
      }}
    >
      {!openSubs ? (
        <Wrapper>
          <div className="ant-descriptions-title">Portal do Estagiário</div>
          <br />
          <Alert
            message="Inscrições Encerradas"
            type="warning"
            showIcon
            closable
          />
          <br />
          <p>Gentileza consultar o período de inscrição no edital.</p>
        </Wrapper>
      ) : (
        <Wrapper>
          <Form
            layout="vertical"
            autoComplete="off"
            onFinish={finish}
            form={form}
            className="formConteiner"
            name="basic"
          >
            <DadosPessoal />

            <Endereco form={form} setLoading={setLoading} />

            <Sistema form={form} updateFile={updateFile} />
            <br />
            <Collapse defaultActiveKey={["1"]} onChange={callback}>
              <Panel
                className="panelStyle"
                header="14. DAS DISPOSIÇÕES GERAIS"
                key="1"
              >
                <p>
                  14.1. A inscrição do candidato implicará a aceitação das
                  normas contidas neste Edital e em outros comunicados
                  eventualmente publicados, que serão afixados no site da
                  Secretaria da Segurança Pública e Defesa Social do Ceará
                  https://www.sspds.ce.gov.br.
                </p>
                <p>
                  14.2. A qualquer tempo, pode-se anular a inscrição ou Termo de
                  Compromisso do candidato convocado, desde que seja verificada
                  falsidade de declarações e/ou irregularidade na documentação
                  apresentada.
                </p>
                <p>
                  14.3. O candidato deverá obedecer rigorosamente o Edital e
                  demais comunicados.
                </p>
                <p>
                  14.5. Os casos omissos serão resolvidos pela Coordenadoria de
                  Gestão de Pessoas – COGEP, no que tange à realização da
                  presente seleção.
                </p>
                <p>
                  14.6. Em caso de alteração de dados pessoais e endereço,
                  constantes no formulário de inscrição, o candidato deverá
                  comunicar a Coordenadoria de Gestão de Pessoas – COGEP, para
                  atualização dos dados, sob pena de quando convocado perder o
                  prazo para assumir o estágio, caso não seja localizado.
                </p>
                <p>
                  14.7. Qualquer dúvida referente as informações contidas neste
                  Edital, deverão ser comunicadas à Comissão Organizadora deste
                  Processo Seletivo. SECRETARIA DA SEGURANÇA PÚBLICA E DEFESA
                  SOCIAL, em Fortaleza, 07 de maio de 2025.
                </p>
              </Panel>
            </Collapse>

            <br />

            <div className="conteinarButton">
              <Popconfirm
                title="Declaro que li e estou ciente dos termos acima"
                visible={visible}
                onConfirm={() => {
                  setVisible(false);
                  form.submit();
                }}
                onCancel={() => setVisible(false)}
              >
                <Button
                  className="button"
                  icon={<CheckCircleOutlined />}
                  type="primary"
                  htmlType="button"
                  onClick={showPopconfirm}
                >
                  Salvar
                </Button>
              </Popconfirm>
            </div>
          </Form>

          <Form
            name="basic"
            labelCol={{ span: 4 }}
            wrapperCol={{ span: 10 }}
            initialValues={{ remember: true }}
          ></Form>
        </Wrapper>
      )}
    </Spin>
  );
}

